export default "__VITE_ASSET__vJrjfBUe__"